import { UseQueryResult, useQuery } from "react-query";
import { PericiaMetricDTO } from "../../../../entities/pericia/model/dto";
import { getPericiasMetricsRequest } from "../../../../entities/pericia/api/get-pericias-metrics";
import { isCalendarDateRangeValid, toDateOnlyRange } from "../../../../shared/lib/date-range";

export interface UseGetPericiasMetricsProps {
  startDate: Date;
  endDate: Date;
  enabled: boolean;
}

export const queryKeys = {
  getPericiasMetrics: (props: { start_date: string; end_date: string }) => ["getPericiasMetrics", props]
};

export function useGetPericiasMetrics(props: UseGetPericiasMetricsProps): UseQueryResult<PericiaMetricDTO[]> {
  const hasValidRange = isCalendarDateRangeValid({ start: props.startDate, end: props.endDate });
  const range = hasValidRange
    ? toDateOnlyRange({ start: props.startDate, end: props.endDate })
    : { startDate: "", endDate: "" };
  const args = {
    start_date: range.startDate,
    end_date: range.endDate
  };

  return useQuery(queryKeys.getPericiasMetrics(args), () => getPericiasMetricsRequest(args), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: props.enabled && hasValidRange
  });
}
